<template>
  <generic-modal
    size="large"
    :title="$t('nworkforce exchange configuration')"
    icon="settings"
    image="/images/icons/nvidia_redeem.jpeg"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui three item top attached tabular menu" ref="tabs">
        <a class="item" data-tab="general"
          ><i class="info icon"></i>{{ $t("general") }}</a
        >
        <a class="active item" data-tab="email_request"
          ><i class="code icon"></i> {{ $t("email request template") }}</a
        >
        <a class="active item" data-tab="email_response"
          ><i class="code icon"></i> {{ $t("email response template") }}</a
        >
      </div>
      <div class="ui bottom attached active tab segment" data-tab="general">
        <div class="ui form">
          <div class="field">
            <label for>{{ $t("email gateway") }}</label>
            <div
              class="ui search selection dropdown"
              ref="email_gateway_dropdown"
            >
              <input type="hidden" name="email_gateway" />
              <i class="dropdown icon"></i>
              <div class="default text">{{ $t("email gateway") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="email_request">
        <div class="ui info message">
          <div class="header">{{ $t("hints") }}</div>
          <ul class="list">
            <li v-html="$t('use ${customer} to refer customer name')"></li>
            <li v-html="$t('use ${bundle_image} to refer bundle image')"></li>
            <li v-html="$t('use ${store} to refer store name')"></li>
            <li
              v-html="$t('use ${bundles_name} to refer active bundles name')"
            ></li>
          </ul>
        </div>
        <div class="ui form">
          <div class="two fields">
            <div class="field">
              <label for>{{ $t("send to") }}</label>
              <input
                type="text"
                name="send_to"
                v-model="setup.email_request.send_to"
              />
            </div>
            <div class="field">
              <label for>{{ $t("email subject") }}</label>
              <input
                type="text"
                name="email_subject"
                v-model="setup.email_request.subject"
              />
            </div>
          </div>
        </div>
        <wysywyg
          v-model="setup.email_request.email"
          :show_js="false"
          :show_css="false"
        />
      </div>
      <div class="ui bottom attached tab segment" data-tab="email_response">
        <div class="ui info message">
          <div class="header">{{ $t("hints") }}</div>
          <ul class="list">
            <li v-html="$t('use ${customer} to refer customer name')"></li>
            <li v-html="$t('use ${result} to refer request result')"></li>
            <li v-html="$t('use ${bundle_image} to refer bundle image')"></li>
            <li v-html="$t('use ${bundles_name} to refer bundles name')"></li>
          </ul>
        </div>
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <label for>{{ $t("email subject") }}</label>
              <input
                type="text"
                name="email_subject"
                v-model="setup.email_response.subject"
              />
            </div>
          </div>
        </div>
        <wysywyg
          v-model="setup.email_response.email"
          :show_js="false"
          :show_css="false"
        />
      </div>
    </div>
  </generic-modal>
</template>

<script>
import Wysywyg from "@/components/Wysywyg/Wysywyg";
import { local_api } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  name: "NworkforceExchangeConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    Wysywyg,
  },
  computed: {},
  data() {
    return {
      setup: {
        email_request: {
          email: {
            html: "",
            js: "",
            css: "",
          },
          subject: "",
          send_to: "",
        },
        email_response: {
          email: {
            html: "",
            js: "",
            css: "",
          },
          subject: "",
        },
        email_gateway: "",
      },
      conf: {},
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    init() {
      let vm = this;
      local_api(
        vm,
        "post",
        "/nworkforce_exchange/exchange/do-get-configuration",
      ).then((conf) => {
        vm.conf = conf;

        if (vm.conf.gateways) {
          let vls = vm.conf.gateways.map((gw) => {
            return { name: gw.name, value: gw.messaging_id };
          });
          window
            .jQuery(vm.$refs.email_gateway_dropdown)
            .dropdown("setup menu", { values: vls })
            .dropdown({
              onChange(value) {
                vm.setup.email_gateway = value;
              },
            });
        }

        if (vm.conf.configuration) {
          vm.setup = vm.conf.configuration;
          window
            .jQuery(vm.$refs.email_gateway_dropdown)
            .dropdown("set selected", vm.conf.configuration.email_gateway);
        }
      });
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(
          vm,
          "post",
          "/nworkforce_exchange/exchange/do-save-configuration",
          {
            s: vm.setup,
          },
        )
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    this.init();
    let vm = this;

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
  updated: function() {},
};
</script>
